/**
 * Mock Waitlist Service
 * This provides simulated functionality for when Firebase is not configured.
 */

export const getWaitlistCount = async () => {
  // Return a realistic mock count
  return 1240;
};

export const addToWaitlist = async (data) => {
  console.log('Mock: Adding to waitlist:', data);
  return { success: true, id: 'mock-id-' + Date.now() };
};
